import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Routes from 'Routes';
import { useMediaQuery } from '@material-ui/core';
import styled from 'styled-components';
import { setChatInterface } from 'models/twilio';
import { BEHAVIOR } from 'components/twilio/constants';

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const AddContactMessage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isDesktop = useMediaQuery(`(min-width: ${BEHAVIOR.MOBILE_BREAKPOINT + 1}px)`);

  const onLinkClick = useCallback(() => {
    if (!isDesktop) {
      dispatch(setChatInterface(false));
    }
  }, [isDesktop, dispatch]);

  return (
    <>
      {t('chat.contact_added')}
      <StyledLink to={Routes.contacts} onClick={onLinkClick}>
        {t('chat.view_contact')}
      </StyledLink>
    </>
  );
};

export default AddContactMessage;
